import { render, staticRenderFns } from "./MenusLeftSidebar.vue?vue&type=template&id=70c51707&"
import script from "./MenusLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./MenusLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports